import type { AccountDto } from '@aiai/shared';
import { slotPath } from './accountSlot';

/** Pages that work without a session — boot redirects never move these. */
const PUBLIC_PATHS = ['/login', '/accounts', '/setup', '/forgot-password', '/reset-password', '/invitations'];

export function isPublicPath(path: string): boolean {
  const pathname = path.split(/[?#]/)[0];
  return PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

/**
 * Where to send a tab whose own slot failed to refresh, given the browser's
 * signed-in accounts. null = stay (public page; nobody signed in so
 * ProtectedRoute's /login redirect applies; or this slot is still listed —
 * the refresh failed transiently and redirecting would reload-loop).
 */
export function bootRedirect(args: { slot: number; path: string; accounts: AccountDto[] }): string | null {
  const { slot, path, accounts } = args;
  if (isPublicPath(path) || accounts.length === 0) return null;
  if (accounts.some((a) => a.slot === slot)) return null;
  if (slot === 0) return slotPath(Math.min(...accounts.map((a) => a.slot)), path);
  return '/accounts';
}

/**
 * A bare `/w/<slug>/…` link (notifications, bookmarks) opens under the first
 * signed-in account that is a member of that workspace. null = stay on slot 0.
 */
export function bareLinkTarget(path: string, accounts: AccountDto[]): string | null {
  const member = accounts.find((a) => a.hasWorkspace);
  return member && member.slot !== 0 ? slotPath(member.slot, path) : null;
}
